var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavorites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-47-268h1440v821H-47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-47-268H63v821H-47z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37 -258)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 801,
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 9,
    transform: "translate(20 242)",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 258c1.105 0 2 .902 2 2.014v14.215c0 .556-.448 1.007-1 1.007a.99.99 0 0 1-.56-.173l-5.88-4.001a.994.994 0 0 0-1.12 0l-5.88 4a.996.996 0 0 1-1.389-.27 1.012 1.012 0 0 1-.171-.563v-14.215c0-1.112.895-2.014 2-2.014h12Zm0 2.014H39v12.318l4.32-2.939a2.983 2.983 0 0 1 3.178-.115l.182.115 4.32 2.94v-12.32Z",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/Favorites.4ef2d0db98f3aa1fbaab4cba02bb1a5c.svg";
export { ForwardRef as ReactComponent };